// Documento do cliente (coluna cpf_cnpj) por país. A API não valida o formato, e a
// coluna aceita 25 caracteres. Cada país tem:
// - mask: máscara do react-input-mask a partir dos dígitos (só onde ela é inequívoca)
// - sanitize: sem máscara, limpa o que foi digitado (caracteres aceitos e tamanho)
// - pattern: regex do documento completo, usada no matchRegexp do TextValidator
const FORMATS = {
  BR: {
    // CPF até 11 dígitos, CNPJ a partir do 12º
    mask: digits =>
      digits.length <= 11 ? '999.999.999-99?' : '99.999.999/9999-99',
    pattern:
      '^([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$',
  },
  US: {
    // SSN 999-99-9999 e EIN 99-9999999 têm 9 dígitos: o hífen fica com quem digita
    sanitize: value => value.replace(/[^\d-]/g, '').slice(0, 11),
    pattern: '^(\\d{3}-\\d{2}-\\d{4}|\\d{2}-\\d{7})$',
  },
  PY: {
    // RUC: 5 a 8 dígitos, hífen e o dígito verificador (1234567-8)
    sanitize: value => value.replace(/[^\d-]/g, '').slice(0, 10),
    pattern: '^\\d{5,8}-\\d$',
  },
  ES: {
    // NIF: DNI (12345678Z), NIE (X1234567L) ou CIF (B12345678)
    sanitize: value =>
      value
        .toUpperCase()
        .replace(/[^0-9A-Z]/g, '')
        .slice(0, 9),
    pattern:
      '^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z]|[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J])$',
  },
}

// País desconhecido ou sem tenant usa o formato do BR
export const getDocumentFormat = country => FORMATS[country] || FORMATS.BR
